var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "ca-form" }, [
    _c("div", { staticClass: "ca-section" }, [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.isEdit,
              expression: "isEdit",
            },
          ],
          staticClass: "instructions",
        },
        [
          _c("div", { staticClass: "instructions" }, [
            _vm._v(
              " This order requires that an AVM Report be uploaded with the AVM Summary information. "
            ),
          ]),
          _vm._m(0),
        ]
      ),
    ]),
    _c("div", { staticClass: "ca-section" }, [
      _c("div", { staticClass: "title" }, [_vm._v("AVM Report PDF file")]),
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { label: "Select Report" } },
            [
              _c(
                "el-upload",
                {
                  staticClass: "image-uploader",
                  attrs: {
                    action: "https://httpbin.org/post",
                    "before-upload": _vm.handleBeforeUpload,
                  },
                },
                [
                  _c("div", { staticClass: "el-upload__text" }, [
                    _c("i", { staticClass: "el-icon-upload" }),
                    _vm._v(" Select AVM Report file... "),
                  ]),
                ]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ]),
    _c("div", { staticClass: "ca-section" }, [
      _c("div", { staticClass: "title" }, [_vm._v("AVM Summary")]),
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            {
              staticClass: "w-50",
              attrs: { required: "", label: "Model Name" },
            },
            [
              _c("el-input", {
                attrs: { placeholder: "AVM report model" },
                nativeOn: {
                  keyup: function ($event) {
                    return _vm.handleChange.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.avmDataSubmit.product,
                  callback: function ($$v) {
                    _vm.$set(_vm.avmDataSubmit, "product", $$v)
                  },
                  expression: "avmDataSubmit.product",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "w-50",
              attrs: { required: "", label: "AVM Value" },
            },
            [
              _c("el-input", {
                staticClass: "inputPrice",
                attrs: { type: "number", min: 0, max: 100000000 },
                nativeOn: {
                  keyup: function ($event) {
                    return _vm.handleChange.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.avmDataSubmit.value,
                  callback: function ($$v) {
                    _vm.$set(_vm.avmDataSubmit, "value", $$v)
                  },
                  expression: "avmDataSubmit.value",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ca-single-line" },
        [
          _c(
            "el-form-item",
            { staticClass: "w-50", attrs: { required: "", label: "FSD" } },
            [
              _c("el-input", {
                staticClass: "inputPrice",
                attrs: { type: "number", min: "0", max: "100" },
                nativeOn: {
                  keyup: function ($event) {
                    return _vm.handleChange.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.avmDataSubmit.fSD,
                  callback: function ($$v) {
                    _vm.$set(_vm.avmDataSubmit, "fSD", $$v)
                  },
                  expression: "avmDataSubmit.fSD",
                },
              }),
            ],
            1
          ),
          _c(
            "el-form-item",
            {
              staticClass: "w-50",
              attrs: { required: "", label: "Confidence Score" },
            },
            [
              _c("el-input", {
                staticClass: "inputPrice",
                attrs: { type: "number", min: "0", max: "100" },
                nativeOn: {
                  keyup: function ($event) {
                    return _vm.handleChange.apply(null, arguments)
                  },
                },
                model: {
                  value: _vm.avmDataSubmit.confidence,
                  callback: function ($$v) {
                    _vm.$set(_vm.avmDataSubmit, "confidence", $$v)
                  },
                  expression: "avmDataSubmit.confidence",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "ca-single-line mt-20" },
        [
          _vm.isEdit
            ? _c(
                "el-button",
                {
                  attrs: { type: "success", disabled: _vm.disableSubmit },
                  on: { click: _vm.saveChanges },
                },
                [
                  _vm.submitting
                    ? _c("span", [_vm._v("Uploading changes...")])
                    : _c("span", [_vm._v("Save and Upload AVM Report")]),
                ]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("ol", [
      _c("li", [_vm._v("Create the AVM Report for the property.")]),
      _c("li", [_vm._v("Select the .pdf report file that was created.")]),
      _c("li", [_vm._v("Fill in the AVM Summary information.")]),
      _c("li", [
        _vm._v(
          "Click on Submit to upload the file with the information for use later."
        ),
      ]),
      _c("li", [
        _vm._v(
          " Once the Inspection is completed, you can make the AVM determination and sign the report. "
        ),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }